<template>
    <div>
        <v-app class="p-4">
            <v-dialog v-model="token" max-width="500px">
                <v-card>
                    <v-card-title>
                        ثبت توکن جدید
                    </v-card-title>

                    <v-card-text>
                        <v-text-field
                                label="توکن"
                                outlined dense
                                clear-icon="mdi-close-circle-outline"
                                clearable
                                class="mt-5"
                                v-model="tokenValue"
                        ></v-text-field>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="error" text @click="token = false;tokenValue = '' ">
                            بستن
                        </v-btn>

                        <v-btn color="success" text @click="setToken">
                            ثبت توکن
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     setToken end       ////-->

            <!--      uploadFile      ////-->
            <v-dialog v-model="upload" max-width="500px">
                <v-card>
                    <v-toolbar flat dark color="primary">

                        <v-toolbar-title>آپلود فایل جدید</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-btn icon dark @click="upload = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>

                    </v-toolbar>

                    <v-card-text>
                        <v-file-input
                                label="فایل اکسل"
                                outlined dense
                                clear-icon="mdi-close-circle-outline"
                                clearable
                                show-size
                                class="mt-5"
                                v-model="uploadValue"
                        ></v-file-input>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                                class="btn-upload"
                                @click="UploadFile"
                        >
                            <span class="fa fa-upload ml-1"></span>
                            آپلود فایل
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--      uploadFile end      ////-->
            <div class="col-md-12 mt-5 mt-5 px-0 px-md-3">
                <div class="row pt-5 mt-5 ">
                    <div class="col-md-4">
                        <v-btn @click="upload=true" class="btn-upload" v-status="'excel_upload'">
                            <span class="fa fa-upload mr-2"></span>
                            بارگذاری فایل
                        </v-btn>
                        <v-btn class="mx-3 text-dark btn-update" @click="updateCharge('all')">
                            <span class="material-icons">update</span>
                            بروزرسانی شارژ
                        </v-btn>
                    </div>
                    <div class="col-md-4">
                    </div>
                </div>

                <template>
                    <div class="row mt-5 pt-5">
                        <div @click.stop="updateCharge(file)" class="col-md-4 border-bottom" :class="{
                            'bg-danger':status==='failed',
                            'bg-success':status==='done',
                            'bg-warning':!status,
                        }" v-for="(status,file) in files">
                            <v-avatar>
                                <img src="https://seeklogo.com/images/M/microsoft-excel-logo-68206F4C93-seeklogo.com.png">
                            </v-avatar>

                            <span class="mr-5">{{ file }}</span>

                            <span class="float-left" @click.stop="deleteExcel(file)">
                                <v-btn outlined x-small color="error" v-status="'excel_delete'" fab>
                              <i class="fa fa-trash-alt text-danger"></i>
                          </v-btn></span>
                        </div>
                    </div>
                </template>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Swal from "sweetalert2";

export default {
    name: "files",
    components: {TitleRibbon},
    data() {
        return {
            files: [],
            token: false,
            tokenValue: '',
            upload: false,
            uploadValue: ''
        }
    },
    methods: {
        getFiles() {
            $.ajax({
                url: `${url}/admin/excel`,
                type: 'GET',
                fn: this.getFiles,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.files = data.data
                }
            })
        },
        deleteExcel(val) {
            this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/admin/excel/${val}`,
                        method: 'DELETE',
                        fn: this.deleteExcel,
                        params: [val],
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        msg: true,
                        success: (data) => {
                            this.getFiles();
                        }
                    });
                }
            }));
        },
        setToken() {
            $.ajax({
                url: `${url}/admin/excel`,
                type: 'PUT',
                fn: this.setToken,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token,
                },
                data: {
                    "cookie": this.tokenValue
                },
                msg: true,
                success: (data) => {
                    this.tokenValue = '';
                    this.token = false
                }
            })
        },
        updateCharge(name = "all") {
            $.ajax({
                url: `${url}/admin/excel/execute`,
                type: 'POST',
                fn: this.updateCharge,
                data: {
                    name: name
                },
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token,
                },
                msg: true,
            })
        },
        UploadFile() {
            let formData = new FormData();
            formData.append('file', this.uploadValue);
            $.ajax({
                url: `${url}/admin/excel`,
                type: 'POST',
                fn: this.UploadFile,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token,
                },
                data: formData,
                contentType: false,
                processData: false,
                msg: true,
                statusCode: {
                    200: (data) => {
                        this.upload = false;
                        this.uploadValue = ''
                    },
                }
            })
        }
    },
    mounted() {
        this.getFiles();
    }
}
</script>

<style scoped>

</style>